import VueJS from 'vue'

export const createAbTestsPlugin = (inject) => {
  return {
    install(Vue) {
      const tests = new Vue({
        data: {
          tests: {},
        },
      })

      // eslint-disable-next-line no-param-reassign
      Vue.prototype.$abTests = new Proxy(tests, {
        get(target, key) {
          return target.tests[key]
        },
        set(target, key, value) {
          Vue.set(target.tests, key, value)

          return true
        },
      })

      if (process.client) {
        const existing = window.abTests || {}
        window.abTests = Vue.prototype.$abTests

        /**
         * These existing abTests will be loaded later in the plugin,
         * with the loadExistingAbTests method which has to be called in each nuxt layout
         * to prevent hydrations issues.
         */
        window.existingAbTests = existing
        inject('abTests', window.abTests)
      }
    },
  }
}
export default (_, inject) => {
  VueJS.use(createAbTestsPlugin(inject))
}
